// extracted by mini-css-extract-plugin
export default {"outer":"CookieNotice_outer__9SYE3","notice":"CookieNotice_notice__86AQz","buttons":"CookieNotice_buttons__fQd8C"};